import { trackAnalyticsEvent } from '@eb/site-analytics';
import { Collection } from '../../types';
import {
    ADD_TO_COLLECTION_GA_ACTION,
    BOOKMARK_GA_ACTION,
    CREATE_COLLECTION_GA_ACTION,
    CREATE_COLLECTION_VIEW_GA_ACTION,
    REMOVE_FROM_COLLECTION_GA_ACTION,
    SHOW_ADD_TO_COLLECTION_GA_ACTION,
    UNBOOKMARK_GA_ACTION,
    VIEW_EVENT_GA_ACTION,
} from './constants';

export const trackEventClick = (
    category: string,
    id: string,
    organizerFollowerCount?: number,
) =>
    trackAnalyticsEvent({
        action: VIEW_EVENT_GA_ACTION,
        category,
        label: id,
        metrics: {
            organizerFollowerCount: organizerFollowerCount || 0,
        },
    });

export const trackSaveEvent = (category: string, saved: boolean, id: string) =>
    trackAnalyticsEvent({
        category,
        action: saved ? BOOKMARK_GA_ACTION : UNBOOKMARK_GA_ACTION,
        label: id,
        dimensions: {
            eventId: id,
        },
    });

export const trackShowAddToCollectionView = (
    category: string,
    userCollections?: Collection[],
) => {
    trackAnalyticsEvent({
        category,
        action: SHOW_ADD_TO_COLLECTION_GA_ACTION,
        label: userCollections?.length,
    });
};

export const trackShowCreateCollectionView = (
    category: string,
    userCollections?: Collection[],
) => {
    trackAnalyticsEvent({
        category,
        action: CREATE_COLLECTION_VIEW_GA_ACTION,
        label: userCollections?.length,
    });
};

export const trackCreateCollection = (
    category?: string,
    collectionId?: string,
) => {
    if (category) {
        trackAnalyticsEvent({
            category,
            action: CREATE_COLLECTION_GA_ACTION,
            label: collectionId,
        });
    }
};

export const trackSaveEventToCollection = (
    category?: string,
    isChecked?: boolean,
    collectionId?: string,
) => {
    if (category) {
        const trackingAction = isChecked
            ? ADD_TO_COLLECTION_GA_ACTION
            : REMOVE_FROM_COLLECTION_GA_ACTION;
        trackAnalyticsEvent({
            category,
            action: trackingAction,
            label: collectionId,
        });
    }
};

// The following two actions are NOT consumed anywhere.

// Holding as placeholder until this package
// re-supports the share functionality.
export const trackDidShareEvent = (category: string, eventId: string) => {
    trackAnalyticsEvent({
        category,
        // action: SHARE_EVENT_GA_ACTION,
        label: eventId,
    });
};

// Holding as placeholder until this package
// re-supports the share functionality.
export const trackWillShareEvent = (category: string, eventId: string) => {
    trackAnalyticsEvent({
        category,
        //action: WILL_SHARE_GA_ACTION,
        label: eventId,
    });
};
